import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgHome} from "~/assets/svg/home.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmHomeIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgHome id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
